/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Component, OnInit } from '@angular/core';

import { VirtualServiceStateService }
    from 'ng/modules/virtual-service/services/virtual-service-state.service';

import './vs-logs-collapsed-sidebar.component.less';

/**
 * @description
 *
 *     Component for setting the icon list view of collapsed log sidebar.
 *
 * @author Zhiqian Liu
 */
@Component({
    selector: 'vs-logs-collapsed-sidebar',
    templateUrl: './vs-logs-collapsed-sidebar.component.html',
})
export class VsLogsCollapsedSidebarComponent implements OnInit {
    /**
     * List of single icon name for the upper search section column.
     */
    public searchSectionIconList = ['star'];

    /**
     * List of icon names for generating the collapsed-state sidebar lower icon column section.
     * The default set is for L7/L4 logs.
     */
    public dataSectionIconList = [
        'shield',
        'user',
        'share',
        'switch',
        'exclamation-circle',
    ];

    /**
     * Reference to the virtual service item instance.
     */
    public readonly vs: any; // TODO AV-159345 update type.

    constructor(vsStateService: VirtualServiceStateService) {
        this.vs = vsStateService.virtualService;
    }

    /** @override */
    public ngOnInit(): void {
        if (this.vs.isDNS()) {
            this.dataSectionIconList.shift();
        }
    }
}
